<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-row ">
            <h1>{{title}}</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                <summary class="mcc-button mcc-button--icon-only ">
                    <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                </summary>
                <div class="mcc-popover__content">

                    <p class="mu-mb-00">
                        {{ helpText.title }}
                        <a :href="helpText.url" target="_blank">Read more...</a>
                    </p>
                </div>
            </details>
        </div>
        <div class="mcc-col  mu-d-flex mu-justify-content-end mu-align-items-end">
            <div role="group" class="mcc-button-group mu-d-flex mu-flex-end">
                <router-link :to="CONTEXT_PATH + '/processengine/tasks/customview/new'">
                    <button class="mcc-button mcc-button--primary" id="createCustomViewBtn" title="Create custom view">
                        <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Create Custom View</span>
                    </button>
                </router-link>

            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" class="">
                <ol class="mcc-breadcrumb">
                    <li>Process engine</li>
                    <li>Tasks</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-row" v-if="fetchCall">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card">
                        <div class="mcc-card__body">
                            <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable" title="Task Filters">
                              
                                    <section>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <form id="formIdd">
                                                <div>
                                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-05">
                                                        <label for="name">Task name</label>
                                                        <input type="text" name="task-name" maxlength="100" id="name" :pattern="nameRegex" :value="taskNameRef" @change="taskNameRef = $event.target.value">

                                                    </div>

                                                    <div class=" mcc-segmented-buttons mu-mb-05">
                                                        <fieldset class="mfc-fieldset" aria-required="true" role="radiogroup" segmented size="sm" help-text :value="statusRef" @change="statusRef = $event.target.value" block ref="radioRef" name="status-radioGroup" id="status-radioGroup">
                                                            <legend class="mfc-label">
                                                                Status
                                                            </legend>
                                                            <div class="mcc-segmented-buttons__list mcc-segmented-buttons--sm">
                                                                <input type="checkbox" name="Status_button1" id="Status_button1" value="open" :checked="statusRef==='open'">
                                                                <label class="mcc-segmented-buttons__button" for="Status_button1">
                                                                    <span class="mcc-segmented-buttons__label">Open</span>
                                                                </label>
                                                                <input type="checkbox" name="Status_button2" id="Status_button2" value="completed" :checked="statusRef==='completed'">
                                                                <label class="mcc-segmented-buttons__button" for="Status_button2">

                                                                    <span class="mcc-segmented-buttons__label">Completed</span>
                                                                </label>
                                                                <input type="checkbox" name="Status_button3" id="Status_button3" value="all" :checked="statusRef==='all'">
                                                                <label class="mcc-segmented-buttons__button" for="Status_button3">

                                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                    </div>
                                                    <div class=" mcc-segmented-buttons mu-mb-05">
                                                        <fieldset class="mfc-fieldset mcc-segmented-buttons--sm" aria-required="true" role="radiogroup" segmented size="sm" help-text :value="priorityRef" @change="priorityRef = $event.target.value" block ref="radioRef" name="status-radioGroup" id="status-radioGroup">
                                                            <legend class="mfc-label">
                                                                Priority
                                                            </legend>
                                                            <div class="mcc-segmented-buttons__list">
                                                                <input type="checkbox" name="Priority_button1" id="Priority_button1" value="0" :checked="priorityRef==='0'">
                                                                <label class="mcc-segmented-buttons__button" for="Priority_button1">
                                                                    <span class="mcc-segmented-buttons__label">Low</span>
                                                                </label>
                                                                <input type="checkbox" name="Priority_button2" id="Priority_button2" value="completed" :checked="priorityRef==='completed'">
                                                                <label class="mcc-segmented-buttons__button" for="Priority_button2">

                                                                    <span class="mcc-segmented-buttons__label">Normal</span>
                                                                </label>
                                                                <input type="checkbox" name="Priority_button3" id="Priority_button3" value="100" :checked="priorityRef==='100'">
                                                                <label class="mcc-segmented-buttons__button" for="Priority_button3">

                                                                    <span class="mcc-segmented-buttons__label">High</span>
                                                                </label>
                                                                <input type="checkbox" name="Priority_button4" id="Priority_button4" value=" " :checked="priorityRef === ' '">
                                                                <label class="mcc-segmented-buttons__button" for="Priority_button4">

                                                                    <span class="mcc-segmented-buttons__label">All</span>
                                                                </label>
                                                            </div>
                                                        </fieldset>
                                                    </div>

                                                    <div class="mfc-slim-select-wrapper mu-mb-05">
                                                        <label for="process-selectId">Process</label>
                                                        <select class="mfc-slim-select" aria-label="single_radio_input" :data-value="selectedProcessRef" @change="selectedProcessRef = $event.target.value" ref="processRef" name="process-select" id="process-selectId">
                                                            <option data-placeholder="true" value></option>
                                                            <option v-for="(app,key) in uniquieProcesses" :selected="selectedProcessRef === app" :key="key" :value="app">{{app}}</option>
                                                        </select>
                                                    </div>

                                                    <div class="mfc-slim-select-wrapper mu-mb-05">
                                                        <label for="Assignee-selectId">Assignee</label>
                                                        <select class="mfc-slim-select" aria-label="single_radio_input" :data-value="selectedAssigneeRef" @change="selectedAssigneeRef = $event.target.value" ref="assigneeRef" name="Assignee-select" id="Assignee-selectId" block>
                                                            <option data-placeholder="true" value></option>
                                                            <option :selected="selectedAssigneeRef === 'unassigned'" value="unassigned">NO ASSIGNEE</option>
                                                            <option :selected="selectedAssigneeRef === 'claimed'" value="claimed">CLAIMED</option>
                                                            <option v-for="(app,key) in userList" :selected="selectedAssigneeRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                                        </select>
                                                    </div>

                                                    <div class="mfc-slim-select-wrapper mu-mb-05">
                                                        <label for="owner-selectId">Owner</label>
                                                        <select class="mfc-slim-select" aria-label="single_radio_input" :data-value="selectedOwnerRef" @change="selectedOwnerRef = $event.target.value" ref="ownerRef" name="owner-select" id="owner-selectId" block>
                                                            <option data-placeholder="true" value></option>
                                                            <option v-for="(app,key) in userList" :selected="selectedOwnerRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="mfc-slim-select-wrapper mu-mb-05">
                                                        <label for="owner-selectId">Involving</label>
                                                        <select class="mfc-slim-select" aria-label="single_radio_input" :data-value="selectedInvolvingRef" @change="selectedInvolvingRef = $event.target.value" ref="involvingRef" name="Involving-select" id="Involving-selectId" block>
                                                            <option data-placeholder="true" value></option>
                                                            <option v-for="(app,key) in userList" :selected="selectedInvolvingRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="flatpickr mfc-input-wrapper mfc-input-wrapper--width mu-mb-05" ref="createdDate">
                                                        <label for="CreatedateSelect">Created between</label>
                                                        <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text" id="CreatedateSelect">
                                                            <input type="text" placeholder="Select Date.." data-input="" ref="createdDateinput" name="createdDate" id="createdDateId" prepend icon="calendar" @change="handleStartRangeChange($event)" @ready="handleStartRangeReady()" style="color: black;">
                                                            <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle="">
                                                                <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="flatpickr mfc-input-wrapper mfc-input-wrapper--width mu-mb-05" ref="updatedDate">
                                                        <label for="UpdatedateSelect">Completed between</label>
                                                        <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text" id="UpdatedateSelect">
                                                            <input type="text" placeholder="Select Date.." data-input="" ref="updatedDateInput" name="updatedDate" id="updatedDateId" prepend icon="calendar" @change="handleEndRangeChange($event)" @ready="handleEndRangeReady()" style="color: black;">
                                                            <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle="">
                                                                <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                            </div>

                                        </div>
                                    </section>
                               
                            </Drawer>
                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(2)'}}</span>
                                </button>
                            </div>

                            <mcc-data-table ref="taskListsTable" id="taskListsTableRef"></mcc-data-table>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    </div>

</div>
</template>

<script>
import constantMessages from "../../../messages";
import Table from "@advanced/component-mosaic-table";
import MyTaskListAPI from "../../../services/MyTaskListAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "TaskList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.tasks.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            showHelpText: false,
            showProcesses: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            searchCriteria: {},
            taskListsTable: null,
            userList: [],
            uniquieProcesses: [],
            currentPageSize: null,
            pageType: "All",
            involvingAll: false,
            unclaimedTasks: false,
            assignedTasksList: false,
            title: "Tasks",
            statusRef: "open",
            statusType: "open",
            taskNameRef: "",
            taskName: "",
            priorityRef: " ",
            priority: " ",
            selectedInvolvingRef: "",
            selectedInvolving: "",
            selectedAssigneeRef: "",
            selectedProcessRef: "",
            selectedProcess: "",
            selectedAssignee: "",
            selectedOwnerRef: "",
            selectedOwner: "",
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            updateDialog: false,
            showNoRecords: false,
            updateCall: false,
            fetchCall: false,
            tableData: [],
            filterCount: 0,
            createdDateFlatPickrInstance: null,
            updatedDateFlatPickrInstance: null,
            ProcessSelectId: null,
            AssigneeSelectId: null,
            InvolvingSelectId: null,
            OwnerSelectId: null,
            tableObj: null
        };
    },
    updated() {
        this.flatpickr()
    },
    created() {
        this.pageType = this.$route.name;
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let taskType = localStorage.getItem("taskType");
        if (taskType != null && taskType != "") {
            localStorage.removeItem("taskType");
            if (taskType == "unassigned" || taskType == "claimed") {
                this.selectedAssigneeRef = taskType;
                this.selectedAssignee = taskType;
            } else {
                this.statusRef = taskType;
                this.statusType = taskType;
            }
        }
        if (localStorage.getItem("AllTasks") == "AllTasks") {

            let storedPageSize =
                localStorage.getItem("taskListDropdown");

            if (storedPageSize != null && storedPageSize != "") {
                this.currentPageSize = parseInt(storedPageSize);
            }
            localStorage.removeItem("taskListDropdown");

            let storedName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_taskName"
            );
            if (storedName != null) {
                this.taskName = storedName;
                this.taskNameRef = storedName;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_taskName"
            );

            let storedStatus = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_statusType"
            );
            if (storedStatus != null) {
                this.statusRef = storedStatus;
                this.statusType = storedStatus;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_statusType"
            );

            let storedEndDate = localStorage
                .getItem("DataTables_" + window.location.pathname + "_endDateRangeRef");
            if (storedEndDate != null) {
                let endDateRangStringArr = storedEndDate
                    .split(",");
                if (endDateRangStringArr.length > 1) {
                    this.endDateRangeRef[0] = new Date(endDateRangStringArr[0]);
                    this.endDateRangeRef[1] = new Date(endDateRangStringArr[1]);
                }
                this.updateDateRef();

            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_endDateRangeRef"
            );
            let storedAssignee = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedAssignee"
            );
            if (storedAssignee != null) {
                this.selectedAssignee = storedAssignee;
                this.selectedAssigneeRef = storedAssignee;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedAssignee"
            );
            let storedProcess = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedProcess"
            );
            if (storedProcess != null) {
                this.selectedProcessRef = storedProcess;
                this.selectedProcess = storedProcess;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedProcess"
            );

            let storedInvolving = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving"
            );
            if (storedInvolving != null) {
                this.selectedInvolving = storedInvolving;
                this.selectedInvolvingRef = storedInvolving;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving"
            );
            let storedPriority = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_priority"
            );
            if (storedPriority != null) {
                this.priority = storedPriority;
                this.priorityRef = storedPriority;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_priority"
            );
            let storedOwner = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_selectedOwner"
            );
            if (storedOwner != null) {
                this.selectedOwner = storedOwner;
                this.selectedOwnerRef = storedOwner;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_selectedOwner"
            );
            let storedDateRange = localStorage
                .getItem(
                    "DataTables_" + window.location.pathname + "_startDateRangeRef"
                );
            if (storedDateRange != null && storedDateRange != "") {
                let startDateRangStringArr =
                    storedDateRange.split(",");
                if (startDateRangStringArr.length > 1) {
                    this.startDateRangeRef[0] = new Date(startDateRangStringArr[0]);
                    this.startDateRangeRef[1] = new Date(startDateRangStringArr[1]);
                }
                this.updateDateRef();
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef"
            );

            localStorage.removeItem("AllTasks");
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
        }

        let self = this;
        MyTaskListAPI.getProcesses().then(result => {
            this.userList = result.userList;
            this.uniquieProcesses = result.uniquieProcesses;
            self.showProcesses = true;
            self.fetchCall = true;
        }).finally(() => {
            setTimeout(() => {
                let self = this
                this.ProcessSelectId = new SlimSelect({
                    select: '#process-selectId',
                });
                this.AssigneeSelectId = new SlimSelect({
                    select: '#Assignee-selectId',
                });
                this.OwnerSelectId = new SlimSelect({
                    select: '#owner-selectId',
                });
                this.InvolvingSelectId = new SlimSelect({
                    select: '#Involving-selectId',
                });
            }, 0);
            this.$nextTick(() => {
                    if (this.$refs.taskListsTable.isReady) {
                        this.initTasksTable();
                    } else {
                        this.$refs.taskListsTable.addEventListener("ready", function () {
                            self.initTasksTable();
                        });
                    }
                });
            self.initTasksTable()
        });

    },

    methods: {
        getFilterCount() {
            if (this.statusRef != "")
                this.filterCount += 1;
            if (this.taskNameRef != "")
                this.filterCount += 1;
            if (this.priorityRef != "")
                this.filterCount += 1;
            if (this.selectedInvolvingRef != "")
                this.filterCount += 1;
            if (this.selectedAssigneeRef != "")
                this.filterCount += 1;
            if (this.selectedOwnerRef != "")
                this.filterCount += 1;
            if (this.selectedProcessRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            this.statusType = this.statusRef;
            this.taskName = this.taskNameRef;
            this.priority = this.priorityRef;
            this.selectedInvolving = this.selectedInvolvingRef;
            this.selectedAssignee = this.selectedAssigneeRef;
            this.selectedOwner = this.selectedOwnerRef;
            this.selectedProcess = this.selectedProcessRef;
            this.tableObj = [];
            this.initTasksTable();
            this.updateTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateOrderList(filteredApplicationList) {
            this.filterData = filteredApplicationList;
            this.filterActive = true;
            this.initTasksTable();

        },
        filterFunctionList(filteredRows, filterValue) {

            this.taskName = filterValue;
            this.initTasksTable();
            this.taskName = "";
            return filteredRows.filter(function (f) {
                return (
                    f.name.toString().toLowerCase().includes(filterValue.toLowerCase()) || f.Assignee.toLowerCase().includes(filterValue.toLowerCase()) || f.owner.toLowerCase().includes(filterValue.toLowerCase())
                );
            })
        },
        resetFilter() {
            this.filterCount = 0;
            this.selectedProcess = "";
            this.selectedProcessRef = "";
            this.statusRef = "open";
            this.taskNameRef = "";
            this.taskName = "";
            this.statusType = "open";
            this.priorityRef = " ";
            this.priority = " ";
            this.selectedInvolving = "";
            this.selectedInvolvingRef = "";
            this.selectedAssigneeRef = "";
            this.selectedOwnerRef = "";
            this.selectedOwner = "";
            this.selectedAssignee = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = [];
            this.endDateRangeRef = [];
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.taskListsTable = null;
            this.updateCall = false;
            this.initTasksTable();
            flatpickr("#createdDateId").destroy();
            flatpickr("#updatedDateId").destroy();
            this.ProcessSelectId.setSelected([]);
            this.AssigneeSelectId.setSelected([]);
            this.OwnerSelectId.setSelected([]);
            this.InvolvingSelectId.setSelected([]);

        },
        flatpickr() {
            let self = this;

            self.createdDateFlatPickrInstance = flatpickr(this.$refs.createdDate, {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
            });
            self.updatedDateFlatPickrInstance = flatpickr(this.$refs.updatedDate, {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],
            });
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (self.startDateRangeRef.length > 0) {
                let startDateFrom = self.startDateRangeRef[0];
                let startDateTo = self.startDateRangeRef[1];
                let d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                if (!startDateTo) {
                    startDateTo = startDateFrom
                }
                this.startedAfter = d.toISOString();
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (!self.unclaimedTasks && self.endDateRangeRef.length > 0) {
                let endDateFrom = self.endDateRangeRef[0];
                let endDateTo = self.endDateRangeRef[1];
                let d = new Date(endDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                if (!endDateTo) {
                    endDateTo = endDateFrom
                }
                this.finishedAfter = d.toISOString();
                d = new Date(endDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = d.toISOString();
            }
        },
        getTasksList(queryString) {
            let self = this;
            return MyTaskListAPI.getAllTasks(queryString, []).then(result => {
                let responseData = {
                    totalCount: 0,
                    data: []
                };
                responseData.totalCount = result.page.totalElements;
                result.data.forEach(item => {
                    item['createdDateString'] = item['createdDate'] != null ? Utils.getMomentDateString(item['createdDate']) : ''
                    item['dueDateObjectString'] = item['dueDateObject'] != null ? Utils.getMomentDateString(item['dueDateObject']) : ''
                    item['claimedDateString'] = item['claimedDate'] != null ? Utils.getMomentDateString(item['claimedDate']) : ''
                    item['completedDateString'] = item['completedDate'] != null ? Utils.getMomentDateString(item['completedDate']) : ''
                    item['durationInMillis'] = item['durationInMillis'] != null ? item['durationInMillis'] + ' ms' : '';
                    item['workTimeInMillis'] = item['workTimeInMillis'] != null ? item['workTimeInMillis'] + ' ms' : '';
                });
                responseData.data = result.data;
                self.updateCall = true;
                return responseData;
            });
        },
        initTasksTable() {
            let self = this;
            if (self.currentPageSize == null) {
                self.currentPageSize = 10;
            }
            const filesTable = document.querySelector('#taskListsTableRef');
            self.taskListsTable = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No tasks found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,

                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true,
                            columnSearch: false
                        },
                        assignee: {
                            type: "string",
                            title: "Assignee",
                            sortable: true,
                            columnSearch: false
                        },
                        owner: {
                            type: "string",
                            title: "Owner",
                            sortable: true,
                            columnSearch: false
                        },
                        prettyStartTime: {
                            type: "string",
                            title: "Created",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{createdDateString}}</div></div>',
                            columnSearch: false
                        },
                        prettyDueDate: {
                            type: "string",
                            title: "Due",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyDueDate}}</u><div>{{dueDateObjectString}}</div></div>',
                            columnSearch: false
                        },
                        prettyClaimTime: {
                            type: "string",
                            title: "Claimed",
                            template: '<div class="dateTemplate"><u>{{prettyClaimTime}}</u><div>{{claimedDateString}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        },
                        prettyEndTime: {
                            type: "string",
                            title: "Completed",
                            template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{completedDateString}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        prettyDurationInMillis: {
                            type: "string",
                            title: "Duration",
                            template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        priority: {
                            type: "string",
                            title: "Priority",
                            sortable: true,
                            columnSearch: false
                        },
                        prettyWorkTimeInMillis: {
                            type: "string",
                            title: "Work time",
                            template: '<div class="dateTemplate"><u>{{prettyWorkTimeInMillis}}</u><div>{{workTimeInMillis}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (start, limit, sortHeader, sortDirection, fullTextQuery, searchColumns) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.taskListsTable != null) {
                            self.currentPageSize =
                                self.taskListsTable.tableContext.store.state.pageSize;
                        }
                        let sortHeaderData = sortHeader == null ? "" : sortHeader;
                        let sortDir = sortDirection == null ? "" : sortDirection;
                        if (sortHeaderData == "prettyStartTime") {
                            sortHeaderData = "startTime";
                        } else if (sortHeaderData == "prettyEndTime") {
                            sortHeaderData = "endTime";
                        } else if (sortHeaderData == "prettyDurationInMillis") {
                            sortHeaderData = "duration";
                        } else if (sortHeaderData == "prettyDueDate") {
                            sortHeaderData = "dueDate";
                        } else if (sortHeaderData == "prettyCreateTime") {
                            sortHeaderData = "createTime";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeaderData +
                            "&dir=" +
                            sortDir +
                            "&involvingAll=false&withoutVariable=true";
                        let filterPresent = false;

                        if (self.selectedProcess != "") {
                            queryString += "&processDefinitionName=" + self.selectedProcess;
                            filterPresent = true;
                        }

                        if (self.taskName != "") {
                            queryString += "&taskName=" + self.taskName;
                            filterPresent = true;
                        }

                        if (self.startedAfter != "") {
                            queryString +=
                                "&taskCreatedAfter=" +
                                self.startedAfter +
                                "&taskCreatedBefore=" +
                                this.startedBefore;
                            filterPresent = true;
                        }
                        if (self.finishedAfter != "") {
                            queryString +=
                                "&taskCompletedAfter=" +
                                self.finishedAfter +
                                "&taskCompletedBefore=" +
                                self.finishedBefore;
                            filterPresent = true;
                        }
                        if (self.statusType == "open") {
                            queryString = queryString + "&finished=false";
                            filterPresent = true;
                        } else if (self.statusType == "completed") {
                            queryString = queryString + "&finished=true";
                            filterPresent = true;
                        }
                        if (self.selectedInvolving != "") {
                            queryString += "&taskInvolvedUser=" + encodeURI(self.selectedInvolving);
                            filterPresent = true;
                        }
                        if (self.priority.trim() != "") {
                            queryString += "&taskPriority=" + self.priority;
                            filterPresent = true;
                        }
                        if (self.selectedOwner != "") {
                            queryString += "&taskOwner=" + encodeURI(self.selectedOwner);
                            filterPresent = true;
                        }
                        if (self.selectedProcessRef != "") {
                            filterPresent = true;
                        }
                        if (self.selectedAssignee != "") {
                            queryString += "&taskAssignee=" + encodeURI(self.selectedAssignee);
                            filterPresent = true;
                        }
                        if (self.assignedTasksList) {
                            queryString += "&currentUser=true";
                            filterPresent = true;
                        }
                        if (filterPresent) {
                            queryString += "&filterInput=true";
                        }
                        return this.getTasksList(queryString);
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });

        },
        updateTemplate() {
            let self = this;
            this.$refs.taskListsTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/tasks/" + reference.trim()
                            );
                        }
                    });
                });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("taskListDropdown", this.taskListsTable.tableContext.store.state.pageSize);

            if (this.selectedProcess != null && this.selectedProcess != "") {
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_selectedProcess",
                    this.selectedProcess
                );
            }

            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_taskName",
                this.taskName
            );
            if (!this.unclaimedTasks) {
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_statusType",
                    this.statusType
                );
                localStorage.setItem(
                    "DataTables_" + window.location.pathname + "_endDateRangeRef",
                    this.endDateRangeRef
                );
            }
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedAssignee",
                this.selectedAssignee
            );

            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_priority",
                this.priority
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedOwner",
                this.selectedOwner
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_selectedInvolving",
                this.selectedInvolving
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef",
                this.startDateRangeRef
            );

        }
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}
</style>
